import { useParams } from "react-router";
import { Chat42Error } from "@/core/error";


export const useAgentId = () => {
    const { agentId: agentIdParam } = useParams() as {agentId: string};
    const agentId = parseInt(agentIdParam);

    if (!agentId) {
        throw new Chat42Error("400");
    }
    return agentId;
};
